<template>

    <div class="max-w-lg" :class="isCentered ? 'text-center mx-auto' : 'text-center mx-auto md:text-left md:mx-0'">
        <div :class="isReverse ? 'text-white' : 'text-secondary-500'" class="text-sm uppercase font-bold">{{subheader}}</div>
        <div :class="isReverse ? 'text-white' : 'text-secondary-900'" class="text-2xl md:text-4xl font-headings mt-3">{{title}}</div>
    </div>

</template>

<script setup>
defineProps({
    subheader: {
        type: String,
        required: true
    },
    title: {
        type: String,
        required: true
    },
    isCentered: {
        type: Boolean,
        default: false
    },
    isReverse: {
        type: Boolean,
        default: false
    }
})
</script>